import { Datoblock } from "./Types";

export interface ConfirmDetailsQueryResponse {
    roadside?: {
        confirmDetailsAlertBoxInfo: Datoblock;
        confirmDetailsDisclaimer: Datoblock;
    };
    lifestyle?: {
        confirmDetailsAlertBoxInfo: Datoblock;
    };
}

export const ConfirmDetailsQuery = `
{
    roadside {
        confirmDetailsAlertBoxInfo {
            blocks
            links
            value
        },
        confirmDetailsDisclaimer {
            blocks
            links
            value
        }
    }
    lifestyle {
        confirmDetailsAlertBoxInfo {
            blocks
            links
            value
        }
    }
}`;
